export default __webpack_public_path__ + "static/media/logo_unicef_azul_nofondo.280a4217.png";